/**
 * Do not edit directly
 * Generated on Fri, 17 Mar 2023 04:59:02 GMT
 */
export const StrokeS = "1px";
export const StrokeM = "2px";
export const StrokeL = "3px";
export const StrokeXl = "4px";
